/* ============================================================
   PIERRE MARSON — Theme JavaScript
   Header · Mega Menu · Mobile Nav · Cart Drawer
   Product Page · Scroll Reveals · Accordion · Forms
   ============================================================ */

(function () {
  'use strict';

  /* ── Utilities ───────────────────────────────────────────── */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'EUR';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(cents / 100);
  }

  /* ── Header: scroll-triggered state ─────────────────────── */
  const header = $('.site-header');

  function updateHeader() {
    if (!header) return;
    const isHeroPage = header.dataset.transparent === 'true';
    if (window.scrollY > 80) {
      header.classList.add('is-scrolled');
      header.classList.remove('is-transparent');
    } else {
      header.classList.remove('is-scrolled');
      if (isHeroPage) header.classList.add('is-transparent');
    }
  }

  window.addEventListener('scroll', updateHeader, { passive: true });
  updateHeader();

  /* ── Mega Menu ───────────────────────────────────────────── */
  const megaMenu    = $('.mega-menu');
  let megaTimeout   = null;
  let activeTrigger = null;

  function openMega(trigger) {
    clearTimeout(megaTimeout);
    if (!megaMenu) return;
    const panel = trigger.dataset.megaPanel;
    $$('.mega-panel, .mega-menu__panel').forEach(p => p.hidden = true);
    const activePanel = megaMenu.querySelector(`[data-panel="${panel}"]`);
    if (activePanel) activePanel.hidden = false;
    megaMenu.classList.add('is-open');
    if (header) header.classList.add('mega-open');
    activeTrigger = trigger;
    trigger.setAttribute('aria-expanded', 'true');
  }

  function closeMega() {
    megaTimeout = setTimeout(() => {
      if (!megaMenu) return;
      megaMenu.classList.remove('is-open');
      if (header) header.classList.remove('mega-open');
      if (activeTrigger) {
        activeTrigger.setAttribute('aria-expanded', 'false');
        activeTrigger = null;
      }
    }, 140);
  }

  $$('.nav__link[data-mega-panel]').forEach(trigger => {
    trigger.addEventListener('mouseenter', () => openMega(trigger));
    trigger.addEventListener('mouseleave', closeMega);
    trigger.addEventListener('focus', () => openMega(trigger));
  });

  if (megaMenu) {
    megaMenu.addEventListener('mouseenter', () => clearTimeout(megaTimeout));
    megaMenu.addEventListener('mouseleave', closeMega);
  }

  document.addEventListener('click', e => {
    if (!megaMenu) return;
    if (header && !header.contains(e.target)) closeMega();
  });

  /* ── Mega menu tab switching ─────────────────────────────── */
  document.querySelectorAll('.mega-tab').forEach(function(tab) {
    tab.addEventListener('mouseenter', function() {
      var panel = tab.closest('.mega-panel');
      if (!panel) return;
      var tabId = tab.dataset.tab;
      panel.querySelectorAll('.mega-tab').forEach(function(t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      panel.querySelectorAll('.mega-editorial-pane, .mega-cards-pane').forEach(function(p) { p.classList.remove('is-active'); });
      var pane = panel.querySelector('[data-pane="' + tabId + '"]');
      if (pane) pane.classList.add('is-active');
    });
    tab.addEventListener('click', function() {
      tab.dispatchEvent(new Event('mouseenter'));
    });
  });

  /* ── Mobile Navigation — fully handled by theme.liquid inline script ── */

  /* ── Cart Drawer ─────────────────────────────────────────── */
  const cartDrawer = $('.cart-drawer');
  const backdrop   = $('.pm-backdrop');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    backdrop?.classList.add('active');
    document.body.style.overflow = 'hidden';
    cartDrawer.setAttribute('aria-hidden', 'false');
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    backdrop?.classList.remove('active');
    document.body.style.overflow = '';
    cartDrawer.setAttribute('aria-hidden', 'true');
  }

  $$('[data-cart-trigger]').forEach(btn => btn.addEventListener('click', () => {
    fetchCart();
    openCart();
  }));
  $$('[data-cart-close]').forEach(btn => btn.addEventListener('click', closeCart));
  backdrop?.addEventListener('click', closeCart);

  async function fetchCart() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
      return cart;
    } catch (e) {
      console.warn('Cart fetch failed', e);
      return null;
    }
  }

  function renderCart(cart) {
    const body     = $('.cart-drawer__body');
    const subtotal = $('.cart-drawer__subtotal-price');
    if (!body) return;

    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-drawer__empty">
          <p>Your selection is empty.<br>Discover our collections.</p>
        </div>`;
      return;
    }

    body.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item__img"
             src="${item.featured_image?.url || item.image || ''}"
             alt="${item.product_title}"
             loading="lazy"
             width="72">
        <div>
          <p class="cart-item__title">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="cart-item__variant">${item.variant_title}</p>`
            : ''}
          <div class="cart-item__footer">
            <div class="cart-item__qty">
              <button class="cart-item__qty-btn" data-change="-1" data-key="${item.key}" aria-label="Decrease">−</button>
              <span>${item.quantity}</span>
              <button class="cart-item__qty-btn" data-change="1" data-key="${item.key}" aria-label="Increase">+</button>
            </div>
            <span class="cart-item__price">${formatMoney(item.final_line_price)}</span>
          </div>
        </div>
      </div>`).join('');

    body.querySelectorAll('[data-change]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key  = btn.dataset.key;
        const item = cart.items.find(i => i.key === key);
        if (!item) return;
        const newQty = item.quantity + parseInt(btn.dataset.change);
        await updateCartItem(key, newQty);
      });
    });
  }

  async function updateCartItem(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await fetchCart();
      await updateCartCount();
    } catch (e) { console.warn('Cart update failed', e); }
  }

  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      $$('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (e) {}
  }

  /* ── Add to Cart ─────────────────────────────────────────── */
  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();

    const variantId = btn.dataset.variantId || $('[name="id"]')?.value;
    if (!variantId) return;

    const label = btn.textContent.trim();
    btn.disabled = true;
    btn.textContent = '…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Add to cart failed');
      }

      btn.textContent = 'Added';
      await fetchCart();
      await updateCartCount();
      openCart();

      setTimeout(() => {
        btn.textContent = label;
        btn.disabled = false;
      }, 1200);

    } catch (err) {
      console.error(err);
      btn.textContent = 'Error — try again';
      btn.disabled = false;
    }
  });

  /* ── Accordions ──────────────────────────────────────────── */
  $$('.product-specs__toggle, [data-specs-toggle]').forEach(toggle => {
    toggle.addEventListener('click', () => {
      const block = toggle.closest('.product-specs, .pm-specs');
      if (!block) return;
      block.classList.toggle('is-open');
      block.classList.toggle('open');
      toggle.setAttribute('aria-expanded',
        block.classList.contains('is-open') || block.classList.contains('open'));
    });
  });

  /* ── Variant Selector ────────────────────────────────────── */
  const variantSelects = $$('.variant-select, .pm-select');
  const variantInput   = $('[name="id"]');

  function updateVariant() {
    if (!window.__productVariants || !variantInput) return;
    const selected = variantSelects.map(s => s.value);
    const match = window.__productVariants.find(v =>
      v.options.every((o, i) => o === selected[i])
    );
    if (!match) return;
    variantInput.value = match.id;

    const priceEl = $('.product-identity__price, #ProductPrice, #pp-price');
    if (priceEl) priceEl.textContent = formatMoney(match.price);

    const addBtns = $$('[data-add-to-cart]');
    addBtns.forEach(addBtn => {
      addBtn.dataset.variantId = match.id;
      if (!match.available) {
        addBtn.disabled = true;
        addBtn.textContent = 'No Longer Available';
      } else {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Bag';
      }
    });
  }

  variantSelects.forEach(s => s.addEventListener('change', updateVariant));

  /* ── Scroll Reveals ──────────────────────────────────────── */
  const revealEls = $$('.reveal');

  if ('IntersectionObserver' in window && revealEls.length) {
    const revealObs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('visible');
        revealObs.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(el => {
      if (el.closest('.products-grid')) {
        const idx = $$('.products-grid .reveal').indexOf(el);
        el.style.transitionDelay = `${(idx % 4) * 0.07}s`;
      }
      revealObs.observe(el);
    });
  } else {
    revealEls.forEach(el => el.classList.add('visible'));
  }

  /* ── Newsletter Form ─────────────────────────────────────── */
  $$('.pm-newsletter-form').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const email = form.querySelector('[type="email"]').value.trim();
      const btn   = form.querySelector('[type="submit"]');
      const msg   = form.querySelector('.pm-form__message');
      if (!email) return;
      btn.disabled = true;
      if (msg) msg.textContent = '';
      try {
        const fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('customer[email]', email);
        fd.append('customer[tags]', 'newsletter');
        await fetch('/', {
          method: 'POST',
          body: fd,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (msg) msg.textContent = 'Thank you. You are now on the private list.';
        form.querySelector('[type="email"]').value = '';
      } catch (err) {
        if (msg) msg.textContent = 'Something went wrong. Please try again.';
      } finally {
        btn.disabled = false;
      }
    });
  });

  /* ── Init ────────────────────────────────────────────────── */
  updateCartCount();

})();